/**
Объект с описанием онтологии
Содержит данные OWL в виде, удобном для работы в js
Загружается в приложение с сервера.
На сервере динамически на лету создается из OWL.
Или генерится отдельным скриптом и кэшируется как статик файл.
*/

import i18n from 'i18next';

const getOntology = () => ({
    
	// типы преставлений 
	classes: [
		{
			// uri и название типа
			id: 'table', name: i18n.t('ontology.classes.table.name'),
			// описание свойств, по котрому будет строиться форма редактирования
			props:[
				hide_in_list(),
				view_title(i18n.t('ontology.classes.table.defaultTitle')), 
				view_description(), 
				src_endpoint(), 
				page_size(),
				src_query(),
				columns('table'),
				border_table(),
				border_width(),
				border_color(),
				//Нумерацию строк таблицы
				row_numbering(),
				//Добавление пространство имён для замены URI на короткие
				namespaces()
			]
		},{
			id: 'list',	name: i18n.t('ontology.classes.list.name'),
			props:[
				hide_in_list(),
				view_title(i18n.t('ontology.classes.list.defaultTitle')),
				view_description(), 
				src_endpoint(), 
				page_size(),
				src_query(),
				columns('list'),
				borders(['empty', 'table', 'rows']),
				border_width(),
				border_color()
			]
		},{
			id: 'tree',	name: i18n.t('ontology.classes.tree.name'),
			props:[
				hide_in_list(),
				view_title(i18n.t('ontology.classes.tree.defaultTitle')),
				view_description(), 
				src_endpoint(), 
				page_size(),
				_positiveInteger(
					'tree_width',
					i18n.t('ontology.props_extra.tree_width'),
					{
						default:     100,
						restriction: {
							minCardinality: 0,
							cardinality:    1
						}
					}
				),
				_required_string(
					'src_query',
					i18n.t('ontology.props_extra.src_query_root'),
					{
						restriction: {
							multiline: true
						},
						comment: i18n.t('ontology.comments.src_query_root')
					}
				),
				link_column('link_view', i18n.t('ontology.props.link_view'), 'views'),
				columns('tree'),
				src_query_children(),
				borders(['empty', 'table']),
				border_width(),
				border_color(),
			]
		},{
			id: 'graph', name: i18n.t('ontology.classes.graph.name'),
			props:[
				hide_in_list(),
				view_title(i18n.t('ontology.classes.graph.defaultTitle')),
				view_description(),
				src_endpoint('endpoint'),
				_required_string(
					'graph',
					i18n.t('ontology.props_extra.graph_name')
				),
				src_query('sparql', null),
				_boolean('typeAsSuperClass', i18n.t('ontology.props_extra.type_as_superclass'), false, true),
				_string(
					'show_type',
					i18n.t('ontology.props_extra.show_type'),
					{
						default:     'emd',
						restriction: {
							cardinality: 1,
							enumeration: ['emd', 'owl', 'sparql']
						}
					}
				),
				graph_uris('typesFilter',  i18n.t('ontology.props_extra.graph_types_filter')),
				graph_uris('linksFilter',  i18n.t('ontology.props_extra.graph_links_filter')),
				graph_uris('labelsFilter', i18n.t('ontology.props_extra.graph_labels_filter')),
				graph_uris('createTypes',  i18n.t('ontology.props_extra.graph_create_types')),
				_required_string('namespaces', i18n.t('ontology.props_extra.namespaces')),
				_optional_string('extra_options', i18n.t('ontology.props_extra.extra_options'), {
					restriction: {
						multiline: true
					}}),
				_optional_string('legend', i18n.t('ontology.props_extra.legend'), {
					restriction: {
						multiline: true
					}}
				),
			]
		},{
			id: 'multi', name: i18n.t('ontology.classes.multi.name'),
			props: [
				hide_in_list(),
				view_title(i18n.t('ontology.classes.multi.defaultTitle')),
				opt_view_description(),
				{
					id:    'views',
					name: i18n.t('ontology.props_extra.next_multi_item'),
					type:  'object',
					props: [
						link_column('view', i18n.t('ontology.props_extra.linked_view'), 'views'),
					],
					restriction: {
						minCardinality: 1
					}
				},
			]
		},{
			id: 'html', name: i18n.t('ontology.classes.html.name'),
			props: [
				hide_in_list(),
				view_title(i18n.t('ontology.classes.html.defaultTitle')),
				opt_view_description(),
				_required_string(
					'html_code',
					i18n.t('ontology.props_extra.html_code'),
					{
						restriction: {
							multiline: true
						},
					}
				),
			]
		},
		{
			id: 'cmp', name: i18n.t('ontology.classes.cmp.name'),
			props: [
				hide_in_list(),
				view_title(i18n.t('ontology.classes.cmp.defaultTitle')),
				opt_view_description(),
				src_endpoint(),
				page_size(),
				src_query('src_query', i18n.t('ontology.comments.src_query_cmp')),
				link_column('graph_list', i18n.t('ontology.props_extra.graph_list'), 'views'),
				columns('table'),
				border_table(),
				border_width(),
				border_color()
			]
		},
		{
			id: 'exporter', name: i18n.t('ontology.classes.exporter.name'),
			props: [
				hide_in_list(),
				view_title(i18n.t('ontology.classes.exporter.defaultTitle')),
				opt_view_description(),
				src_endpoint(),
				_required_string('gen_endpoint', i18n.t('ontology.props_extra.gen_endpoint')),
				exporter_params(
					'sparqls',
					i18n.t('ontology.props_extra.sparqls'),
					{
						var_name: i18n.t('ontology.props_extra.sparqls_var_name'),
						query:    i18n.t('ontology.props_extra.sparqls_query')
					},
					{
						endpoint: i18n.t('ontology.props_extra.sparqls_endpoint')
					}
				),
				exporter_params(
					'templates',
					i18n.t('ontology.props_extra.templates'),
					{
						file_name: i18n.t('ontology.props_extra.templates_file_name'),
						content:   i18n.t('ontology.props_extra.templates_content')
					}
				),
				_string(
					'gen_type',
					i18n.t('ontology.props_extra.gen_type'),
					{
						default:     'html',
						restriction: {
							cardinality: 1,
							enumeration: ['html', 'word']
						}
					}
				),
			]
		},
	]

});

export default getOntology;

// толщина рамки
function border_width() {
	return _positiveInteger(
		'border_width', 
		i18n.t('ontology.props.border_width'), {
			default:     1, 
			restriction: {
				cardinality: 1
			}
		}
	);
}

// Цвет рамки
function border_color() {
	return color(
		'border_color', 
		i18n.t('ontology.props.border_color'), 
		'#000000'
	);
}

//Показать номер строки
function row_numbering(){
	const props = [];
	props.push(_boolean('show_numbering',   i18n.t('ontology.props.show_numbering'), false, true));
	props.push(_optional_string('col_width',     i18n.t('ontology.props.col_width')));
	props.push(_optional_string('col_width_min', i18n.t('ontology.props.col_width_min')));

	props.forEach(prop => {
		prop.restriction["inLine"] = true;
		prop.bootstrap = "col-3";
	});

	return {
		id:          'row_numbering',
		name:        i18n.t('ontology.props.row_numbering'),
		type:        'object',
		props:       props,
		restriction: {		
			maxCardinality: 1,
			//Отображать в строку
			inLine: true
		}
	};
}

function namespaces(){
	const props = [];
	props.push(_required_string('namespace_prefix', i18n.t('ontology.props.namespace_prefix'),
		{default: "-", restriction: {inLine: true}, bootstrap: "col-3"}));// default: "rdf"
	props.push(_required_string('namespace_uri', 		i18n.t('ontology.props.namespace_uri'), 
		{default: "-", restriction: {inLine: true}, bootstrap: "flex-grow-1"}));// default: "<http://www.w3.org/1999/02/22-rdf-syntax-ns#"}
	return {
		id:          'namespaces',
		name:        i18n.t('ontology.props_extra.namespaces'),
		type:        'object',
		props:       props,
		restriction: {
			minCardinality: 1,		
			//Отображать в строку
			inLine: true
		}
	};
}

function columns(type) {
	const props = [];

	props.push(_required_string('col_field', i18n.t('ontology.props.col_field'),     {editable: false}));
	props.push(_optional_string('col_data',  i18n.t('ontology.props.col_data'), {editable: false}));
	props.push(_boolean(        'col_uri',   i18n.t('ontology.props.col_uri'),      true, false));
	props.push(_boolean(        'col_show',  i18n.t('ontology.props.col_show'), type !== 'table', false));
	if (type !== 'tree') {
		props.push(_boolean(        'alpha_col', i18n.t('ontology.props.alpha_col'), true, true));
		props.push(_required_string('col_title', i18n.t('ontology.props.col_title')));
	}
	props.push(link_column('link_col', i18n.t('ontology.props.link_col'), 'columns'));
	if (type === 'table') {
		props.push(_boolean('col_html',              i18n.t('ontology.props.col_html'), false, true));
		props.push(_boolean('col_group',             i18n.t('ontology.props.col_group'), false, true));
		props.push(_optional_string('col_separator', i18n.t('ontology.props.col_separator'), {default: '" "'}));
		props.push(_optional_string('col_width',     i18n.t('ontology.props.col_width')));
		props.push(_optional_string('col_width_min', i18n.t('ontology.props.col_width_min')));
	}
	props.push(color(      'col_foreground', i18n.t('ontology.props.col_foreground'), '#000000'));
	props.push(color(      'col_background', i18n.t('ontology.props.col_background'),   '#ffffff'));
	props.push(font_size(  'font_size',      i18n.t('ontology.props.font_size')));
	props.push(font_style( 'font_style',     i18n.t('ontology.props.font_style')));
	props.push(font_weight('font_weight',    i18n.t('ontology.props.font_weight')));
	if (type !== 'tree') {
		props.push(alignment('alignment',  i18n.t('ontology.props.alignment')));
	}
	if (type === 'table') {
		props.push(_boolean('col_total',       i18n.t('ontology.props.col_total'), false, false));
		props.push(_boolean('col_short_uri',   i18n.t('ontology.props.col_short_uri'), false, false));
	}
	return {
		id:          'col',
		name:        i18n.t('ontology.common_extra.columns'),
		type:        'object',
		props:       props,
		restriction: {
			minCardinality: 1
		}
	};
}

function link_column(id, name, fill) {
	const props = _string(
		id,
		name,
		{
			default:     i18n.t('ontology.common_extra.no_value'),
			fill:        fill,
			restriction: {
				minCardinality: 0,
				cardinality:    1,
				enumeration:    [i18n.t('ontology.common_extra.no_value')],
			}
		});
	if (fill === 'views') {
		props.restriction.selectSize = 5;
	}
	return props;
}

// заголовок view
function view_title(defval) {
	return _required_string(
		'view_title', 
		i18n.t('ontology.props.view_title'),
		{
			default: defval
		});
}

// описание view
function view_description() {
	const props = opt_view_description();
	props.restriction.minCardinality = props.restriction.cardinality = 1;
	return props;
}

function opt_view_description() {
	return _optional_string(
		'view_description',
		i18n.t('ontology.props.view_description'),
		{
			restriction: {
				multiline: true
			}
		});
}

// эндпойнт запроса
function src_endpoint(id) {
	return _required_string(
		id || 'src_endpoint',
		i18n.t('ontology.props.src_endpoint'));
}

// запрос
function src_query(id, comment) {
	const src_query = _required_string(
		id || 'src_query',
		i18n.t('ontology.props.src_query'), 
		{
			restriction: {
				multiline: true
			}
		}
	);
	if (comment !== undefined) {
		src_query.comment = comment;
	} else {
		src_query.comment = i18n.t('ontology.comments.src_query_default');
	}
	return src_query;
}

// запрос дочерних элементов дерева
function src_query_children() {
	const query = _required_string(
		'src_query', 
		i18n.t('ontology.props_extra.src_query_children'),
		{
			restriction: {
				multiline:   true, 
				cardinality: 1
			},
			comment: i18n.t('ontology.comments.src_query_children')
		}
	);
	return {
		id:    'subtree',
		name:  i18n.t('ontology.common_extra.subtree'),
		type:  'object', 
		props: [
			query,
			link_column('link_view', i18n.t('ontology.props.link_view'), 'views'),
			columns('tree')
		],
		restriction: {
			minCardinality: 1
		}
	}
}

// количество записей на странице таблицы или списка
// целое, неотрицательное, обязательное, по умолчанию 10, 0 означает отсутствие лимита.
function page_size() {
	return _nonNegativeInteger(
		'page_size', 
		i18n.t('ontology.props.page_size'),
		{ 
			default:     10, 
			restriction: {
				cardinality: 1
			},
			comment: i18n.t('ontology.comments.page_size')
		}
	);
}

// цвет
function color(id, name, defval) {
	return _string(
		id, 
		name, 
		{
			default:     defval, 
			restriction: {
				cardinality: 1,
				pattern:     '#[0-9A-Fa-f]{6}'
			}
		});
}

// выравнивание
function alignment(id, name) {
	return _string(
		id, 
		name, 
		{ 
			default:     'left',
			restriction: {
				cardinality: 1, 
				enumeration: ['left', 'center', 'right']
			}
		});
}

// размер шрифта
function font_size(id, name) {
	return _positiveInteger(
		id, 
		name, 
		{ 
			default:     10, 
			restriction: {
				cardinality: 1
			}
		});
}

// начертание шрифта
function font_style(id, name) {
	return _string(
		id, 
		name, 
		{ 
			default:     'normal',
			restriction: {
				cardinality: 1, 
				enumeration: ['normal', 'italic']
			}
		});
}
// насыщенность шрифта
function font_weight(id, name) {
	return _string(
		id, 
		name, 
		{ 
			default:     'normal',
			restriction: {
				cardinality: 1, 
				enumeration: ['normal', 'bold']
			}
		});
}

// разные варианты бордюров
function borders(types) {
	return _string(
		'border',
		i18n.t('ontology.common_extra.border'),
		{
			default:     'empty',
			restriction: {
				cardinality: 1,
				enumeration: types
			}
		}
	);
}

// бордюр в таблице
function border_table() {
	return borders(['empty', 'table', 'rows', 'cells']);
}

// настройки элементов графа
function graph_uris(type, name) {
	const props = [];

	props.push(_required_string('uri', i18n.t('ontology.props_extra.uri')));
	if (['typesFilter', 'labelsFilter'].includes(type)) {
		props.push(color('backgroundColor', i18n.t('ontology.props_extra.background_color'), '#ffffff'));
	}

	return {
		id:          type,
		name:        name,
		type:        'object',
		props:       props,
		restriction: {
			minCardinality: 1,
		}
	};
}

function hide_in_list() {
	return _boolean('hide_in_list', i18n.t('ontology.props.hide_in_list'), false, true);
}

function exporter_params(id, name, props, opt_props) {
	const _props = [];

	_props.push(_required_string(Object.keys(props)[0], Object.values(props)[0]));
	_props.push(_required_string(Object.keys(props)[1], Object.values(props)[1],
		{
			restriction: {
				multiline:   true,
				cardinality: 1
			}
		}
	));

	if (opt_props) {
		_props.push(_optional_string(Object.keys(opt_props)[0], Object.values(opt_props)[0]));
	}

	return {
		id:    id,
		name:  name,
		type:  'object',
		props: _props,
		restriction: {
			minCardinality: 1
		}
	}
}

// маркер элемента списка
// function _marker(id, name) {
// 	return _string(
// 		id, 
// 		name, 
// 		{ 
// 			default:     'disc',
// 			restriction: {
// 				cardinality: 1, 
// 				enumeration: ['none', 'disc', 'square', 'circle']
// 			}
// 		});
// }

/**** Разные owl:DatatypeProperty ****/

// owl:DatatypeProperty
function _data(id, name, type, props) {
	props      = props || {};
	props.id   = id;
	props.name = name;
	props.type = type;  // rdf:range =  any xsd type
	return props;
}

// owl:DatatypeProperty +  xsd:string
function _string(id, name, props) {
	return _data(
		id, 
		name, 
		'xsd:string', 
		props);
}

// обязательная строка
function _required_string(id, name, props) {
	props = props || {};
	props.restriction = props.restriction || {};
	props.restriction.minCardinality = props.restriction.cardinality = 1;
	return _optional_string(id, name, props);
}

// необязательная строка
function _optional_string(id, name, props) {
	props = props || {};
	props.restriction = props.restriction || {};
	props.restriction.minCardinality = props.restriction.minCardinality || 0;
	props.restriction.cardinality = props.restriction.cardinality || 1;
	if (props.restriction.multiline === undefined) {
		props.restriction.multiline = false;
	}
	return _string(
		id,
		name,
		props);
}

// owl:DatatypeProperty +  xsd:positiveInteger
function _positiveInteger(id, name, props) {
	return _data(
		id, 
		name, 
		'xsd:positiveInteger', 
		props);
}

function _nonNegativeInteger(id, name, props) {
	return _data(
		id,
		name,
		'xsd:nonNegativeInteger',
		props);
}

function _boolean(id, name, unique, optional) {
	return _data(
		id, 
		name, 
		'xsd:boolean', 
		{
			default:     'false', 
			restriction: {
				unique:         unique,
				minCardinality: 0,
				cardinality:    1,
				optional:       optional
			}
		});
}
